var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_AtAGlance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B_01",
    transform: "translate(-95.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(96.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Info/Standard",
    transform: "translate(4.000000, 3.000000)",
    fill: "#00B550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(4.680000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.21712744 4.00606878 2.13890762 13 0 13 1.07821982 4.00606878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76062036,1.38503034 C3.76062036,1.5720396 3.72117369,1.74735814 3.64227916,1.91099123 C3.56338464,2.07462433 3.46111549,2.21780114 3.33546864,2.34052596 C3.2098218,2.46325078 3.06518401,2.56113697 2.90155091,2.63418746 C2.73791782,2.70723795 2.56844322,2.74376264 2.39312205,2.74376264 C2.22364492,2.74376264 2.05855329,2.70723795 1.89784221,2.63418746 C1.73713114,2.56113697 1.59541531,2.46325078 1.47269049,2.34052596 C1.34996567,2.21780114 1.25207948,2.07462433 1.179029,1.91099123 C1.10597851,1.74735814 1.06945381,1.5720396 1.06945381,1.38503034 C1.06945381,1.19802109 1.10743949,1.01978057 1.183412,0.850303439 C1.25938451,0.680826305 1.35873169,0.533266531 1.48145651,0.40761969 C1.60418133,0.281972849 1.74589715,0.182625674 1.90660823,0.109575185 C2.0673193,0.0365246966 2.23241093,0 2.40188806,0 C2.57720924,0 2.74668383,0.0365246966 2.91031693,0.109575185 C3.07395002,0.182625674 3.21858782,0.280511861 3.34423466,0.403236682 C3.4698815,0.525961504 3.57068966,0.67206029 3.64666217,0.841537424 C3.72263468,1.01101456 3.76062036,1.19217705 3.76062036,1.38503034 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#00B550",
    cx: 10,
    cy: 10,
    r: 10.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.80ccb9b5b7e4ec0f167081f3b12b193a.svg";
export { ForwardRef as ReactComponent };